export const USE_SEARCH_DASHBOARD = 'USE_SEARCH_DASHBOARD';
